class HeaderMenu {
    constructor() {
        const root = document.querySelector('.header-menu');
        if (root) this.init(root);
    }

    init(root) {
        this.root = root;
        this.header = document.querySelector('header.-main');
        this.main = document.querySelector('main');

        this.megamenuCheckboxes = this.root.querySelectorAll(
            "[type='checkbox'][name='megamenu_checkbox']"
        );
        this.submenuItems = this.root.querySelectorAll(
            '.header-menu__term-item.has-submenu'
        );
        this.childMegamenus = this.root.querySelectorAll(
            '.header-menu__child-megamenu'
        );
        this.attributesMegamenus = this.root.querySelectorAll(
            '.header-menu__attributes-megamenu'
        );

        this.handleMethods();
    }

    handleMethods() {
        this.handleMegamenuCheckboxes();
        this.handleSubmenu();
        this.handleAttributesMenu();
        this.handleBackButtons();
        this.handleClickOutside();
    }

    handleMegamenuCheckboxes() {
        this.megamenuCheckboxes.forEach(checkbox => {
            checkbox.addEventListener('change', e => {
                if (e.target.checked) {
                    this.header.classList.add('-no-overflow');
                    this.megamenuCheckboxes.forEach(cb => {
                        if (cb !== e.target) cb.checked = false;
                    });
                } else {
                    this.header.classList.remove('-no-overflow');
                    this.closeAllSubmenus();
                    this.closeAllAttributesMenus();
                    this.updateMobileClasses();
                }
            });
        });

        this.main.addEventListener('click', () => {
            this.closeAllMegamenus();
        });
    }

    handleSubmenu() {
        this._submenuTimeouts = new Map();
        this.submenuItems.forEach(item => {
            item.addEventListener('mouseenter', e => {
                if (window.innerWidth >= 992) {
                    const termId = item.dataset.termId;
                    const timeoutId = setTimeout(() => {
                        this.openSubmenu(termId);
                    }, 250);
                    this._submenuTimeouts.set(item, timeoutId);
                }
            });
            item.addEventListener('mouseleave', e => {
                if (window.innerWidth >= 992) {
                    const timeoutId = this._submenuTimeouts.get(item);
                    if (timeoutId) {
                        clearTimeout(timeoutId);
                        this._submenuTimeouts.delete(item);
                    }
                }
            });
            item.addEventListener('click', e => {
                if (window.innerWidth >= 992) {
                    const linkElement = item.querySelector('a[href]');
                    if (linkElement?.href) {
                        window.location.href = linkElement.href;
                    }
                } else {
                    e.preventDefault();
                    const termId = item.dataset.termId;
                    this.openSubmenu(termId);
                    this.closeAllAttributesMenus();
                }
            });
        });
        const megamenu = this.root.querySelector('.header-menu__megamenu');
        if (megamenu) {
            megamenu.addEventListener('mouseleave', e => {
                if (window.innerWidth >= 992) {
                    this.closeAllSubmenus();
                }
            });
        }
    }

    handleAttributesMenu() {
        const childCategoryItems = this.root.querySelectorAll(
            '.header-menu__child-megamenu .header-menu__term-item'
        );

        childCategoryItems.forEach(item => {
            item.addEventListener('mouseenter', e => {
                if (window.innerWidth >= 992) {
                    const childTermId = item.dataset.termId;
                    if (!childTermId) return;
                    const hasAttributes =
                        item.classList.contains('has-attributes');
                    if (hasAttributes) {
                        this.openAttributesMenu(childTermId);
                    }
                }
            });
            item.addEventListener('mouseleave', e => {
                if (window.innerWidth >= 992) {
                    const hasAttributes =
                        item.classList.contains('has-attributes');
                    if (hasAttributes) {
                        const openedChildMegamenu = this.root.querySelector(
                            '.header-menu__child-megamenu.-opened'
                        );
                        const parentChildMegamenu = item.closest(
                            '.header-menu__child-megamenu'
                        );
                        if (openedChildMegamenu !== parentChildMegamenu) {
                            this.closeAllAttributesMenus();
                        }
                    }
                }
            });
            item.addEventListener('click', e => {
                const childTermId = item.dataset.termId;
                if (!childTermId) return;
                const hasAttributes = item.classList.contains('has-attributes');
                if (window.innerWidth >= 992) {
                    if (!hasAttributes) {
                        const linkElement = item.querySelector('a[href]');
                        if (linkElement?.href) {
                            window.location.href = linkElement.href;
                        }
                    }
                } else {
                    if (hasAttributes) {
                        e.preventDefault();
                        e.stopPropagation();
                        const parentChildMegamenu = item.closest(
                            '.header-menu__child-megamenu'
                        );
                        if (parentChildMegamenu) {
                            this.clearSelectedLinks(
                                parentChildMegamenu,
                                '.header-menu__child-megamenu-content'
                            );
                        }
                        const clickedLink = item.querySelector(
                            '.card-category-menu__link'
                        );
                        if (clickedLink) clickedLink.classList.add('-selected');
                        this.openAttributesMenu(childTermId);
                    } else {
                        const linkElement = item.querySelector('a[href]');
                        if (linkElement?.href) {
                            window.location.href = linkElement.href;
                        }
                    }
                }
            });
        });
        const childMegamenus = this.root.querySelectorAll(
            '.header-menu__child-megamenu'
        );
        const attributesMegamenus = this.root.querySelectorAll(
            '.header-menu__attributes-megamenu'
        );
        childMegamenus.forEach((childMenu, idx) => {
            const attributesMenu = attributesMegamenus[idx];
            if (!attributesMenu) return;
            const closeAttributesHandler = e => {
                if (window.innerWidth >= 992) {
                    const related = e.relatedTarget;
                    if (
                        !childMenu.contains(related) &&
                        !attributesMenu.contains(related)
                    ) {
                        attributesMenu.classList.remove('-opened');
                        attributesMenu.style.minWidth = '';
                        attributesMenu.style.maxWidth = '';
                        const attrContent = attributesMenu.querySelector(
                            '.header-menu__attributes-content'
                        );
                        if (attrContent) attrContent.style.overflowX = '';
                        this.updateMobileClasses();
                    }
                }
            };
            childMenu.addEventListener('mouseleave', closeAttributesHandler);
            attributesMenu.addEventListener(
                'mouseleave',
                closeAttributesHandler
            );
        });
    }

    clearSelectedLinks(container, selector) {
        const links = container.querySelectorAll(
            `${selector} .card-category-menu__link.-selected`
        );
        links.forEach(link => link.classList.remove('-selected'));
    }

    setSubmenuHeight(submenu) {
        if (window.innerWidth >= 992) {
            const wrapper = submenu.closest(
                '.header-menu__child-megamenu-content'
            );
            const content = submenu.querySelector(
                '.header-menu__child-megamenu-content'
            );
            const container = submenu.querySelector('.header-container');

            if (wrapper && content && container) {
                const originalPosition = submenu.style.position;
                const originalOpacity = submenu.style.opacity;
                const originalTransform = submenu.style.transform;
                const originalVisibility = submenu.style.visibility;
                const originalDisplay = submenu.style.display;

                submenu.style.position = 'static';
                submenu.style.opacity = '1';
                submenu.style.transform = 'none';
                submenu.style.visibility = 'visible';
                submenu.style.display = 'block';

                const computedStyle = window.getComputedStyle(submenu);
                const paddingTop = parseInt(computedStyle.paddingTop, 10);
                const paddingBottom = parseInt(computedStyle.paddingBottom, 10);

                const contentHeight = content.scrollHeight;
                const containerPadding = paddingTop + paddingBottom;
                const totalHeight = contentHeight + containerPadding;

                submenu.style.position = originalPosition;
                submenu.style.opacity = originalOpacity;
                submenu.style.transform = originalTransform;
                submenu.style.visibility = originalVisibility;
                submenu.style.display = originalDisplay;

                const firstColumn = this.root.querySelector(
                    '.header-menu__megamenu-content'
                );
                const firstColumnHeight = firstColumn
                    ? firstColumn.offsetHeight
                    : 0;

                if (totalHeight < firstColumnHeight) {
                    wrapper.style.height = 'auto';
                } else {
                    wrapper.style.height = `${totalHeight}px`;
                }
            }
        }
    }

    resetSubmenuHeight(submenu) {
        if (window.innerWidth >= 992) {
            const wrapper = submenu.closest(
                '.header-menu__child-megamenu-content'
            );
            if (wrapper) {
                wrapper.style.height = '';
            }
        }
    }

    openSubmenu(termId) {
        this.closeAllSubmenus();
        const targetSubmenu = this.root.querySelector(
            `[data-parent-id="${termId}"].header-menu__child-megamenu`
        );
        if (targetSubmenu) {
            targetSubmenu.classList.add('-opened');
            this.setSubmenuHeight(targetSubmenu);
        }
        this.updateMobileClasses();
    }

    openAttributesMenu(termId) {
        this.closeAllAttributesMenus();
        const targetAttributesMenu = this.root.querySelector(
            `[data-parent-id="${termId}"].header-menu__attributes-megamenu`
        );
        if (targetAttributesMenu) {
            this.fixAttributesMenuWidth(targetAttributesMenu);
            targetAttributesMenu.classList.add('-opened');
        }
        this.updateMobileClasses();
    }

    fixAttributesMenuWidth(menu) {
        if (window.innerWidth < 992) return;
        menu.style.minWidth = '';
        menu.style.maxWidth = '';
        const content = menu.querySelector('.header-menu__attributes-content');
        if (!content) return;
        content.style.overflowX = '';
        const groups = content.querySelectorAll('.attributes-group');
        if (!groups.length) return;

        menu.style.transition = 'none';
        menu.style.transform = 'translateX(0%)';
        void menu.offsetHeight;

        const menuRect = menu.getBoundingClientRect();
        let maxRight = 0;
        groups.forEach(group => {
            maxRight = Math.max(maxRight, group.getBoundingClientRect().right);
        });
        const paddingRight =
            parseFloat(getComputedStyle(menu).paddingRight) || 0;
        const neededWidth = Math.ceil(maxRight - menuRect.left + paddingRight);
        const edgeGap = 16;
        const container = menu.closest('.header-container');
        const rightBound = container
            ? container.getBoundingClientRect().right
            : document.documentElement.clientWidth;
        const availableWidth = Math.floor(rightBound - menuRect.left - edgeGap);

        menu.style.transition = '';
        menu.style.transform = '';
        void menu.offsetHeight;

        if (neededWidth > availableWidth) {
            menu.style.maxWidth = availableWidth + 'px';
            content.style.overflowX = 'auto';
        } else if (neededWidth > Math.ceil(menuRect.width)) {
            menu.style.minWidth = neededWidth + 'px';
        }
    }

    closeAllSubmenus() {
        this.childMegamenus.forEach(submenu => {
            this.resetSubmenuHeight(submenu);
            submenu.classList.remove('-opened');
            const links = submenu.querySelectorAll(
                '.card-category-menu__link.-selected'
            );
            links.forEach(link => link.classList.remove('-selected'));
        });
        this.updateMobileClasses();
    }

    closeAllAttributesMenus() {
        this.attributesMegamenus.forEach(attributesMenu => {
            attributesMenu.classList.remove('-opened');
            attributesMenu.style.minWidth = '';
            attributesMenu.style.maxWidth = '';
            const content = attributesMenu.querySelector(
                '.header-menu__attributes-content'
            );
            if (content) content.style.overflowX = '';
        });
    }

    updateMobileClasses() {
        const mainMegamenu = this.root.querySelector('.header-menu__megamenu');
        if (!mainMegamenu) return;

        const hasOpenChild = !!this.root.querySelector(
            '.header-menu__child-megamenu.-opened'
        );
        const hasOpenAttributes = !!this.root.querySelector(
            '.header-menu__attributes-megamenu.-opened'
        );

        mainMegamenu.classList.toggle('-child-opened', hasOpenChild);
        mainMegamenu.classList.toggle('-attributes-opened', hasOpenAttributes);
        this.childMegamenus.forEach(child => {
            child.classList.toggle('-attributes-opened', hasOpenAttributes);
        });
        if (!hasOpenChild) {
            this.closeAllAttributesMenus();
        }
    }

    handleBackButtons() {
        const allBackButtons = this.root.querySelectorAll(
            '.header-menu-child__back-wrapper'
        );

        allBackButtons.forEach(button => {
            button.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();

                const openedAttributesMenu = this.root.querySelector(
                    '.header-menu__attributes-megamenu.-opened'
                );
                const openedChildMenu = this.root.querySelector(
                    '.header-menu__child-megamenu.-opened'
                );

                if (openedAttributesMenu) {
                    openedAttributesMenu.classList.remove('-opened');
                    openedAttributesMenu.style.minWidth = '';
                    openedAttributesMenu.style.maxWidth = '';
                    const attrContent = openedAttributesMenu.querySelector(
                        '.header-menu__attributes-content'
                    );
                    if (attrContent) attrContent.style.overflowX = '';
                    this.updateMobileClasses();
                } else if (openedChildMenu) {
                    openedChildMenu.classList.remove('-opened');
                    this.updateMobileClasses();
                } else {
                    this.closeAllMegamenus();
                }
            });
        });
    }

    handleClickOutside() {
        const megamenus = this.root.querySelectorAll('.header-menu__megamenu');

        megamenus.forEach(megamenu => {
            megamenu.addEventListener('click', e => {
                const isInsideContent = e.target.closest(
                    '.header-menu__megamenu-content, .header-menu__child-megamenu, .header-menu__attributes-megamenu'
                );

                if (!isInsideContent) {
                    this.closeAllMegamenus();
                }
            });
        });
    }

    closeAllMegamenus() {
        this.megamenuCheckboxes.forEach(checkbox => {
            checkbox.checked = false;
        });
        this.header.classList.remove('-no-overflow');
        this.closeAllSubmenus();
        this.closeAllAttributesMenus();
        this.updateMobileClasses();
        const allSelectedLinks = this.root.querySelectorAll(
            '.card-category-menu__link.-selected'
        );
        allSelectedLinks.forEach(link => link.classList.remove('-selected'));
    }
}

new HeaderMenu();
